import React from 'react';
import { connect } from 'react-redux';
import { setCurrentSection } from '../../actions/globalConfig';
import CalendarPanel from '../../components/InfoPanels/CalendarPanel';

class EventCalendarView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faqsData: [],
    };
  }

  componentWillMount() {
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  generateHtml (html) {
    return {__html: html};
  }

  render() {
    return (
      <div className="container-fluid content bg-fff-65 py-4">
        <div className="row">
          <div className="col-sm-12 pr-35 pl-35">
            <h1>Event Calendar</h1>
            <div className="text-justify">
              <div className="container-fluid text-left">
                <div className="row">
                  <div className="col-auto position-relative">
                    <CalendarPanel />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>);
  }
}


const mapStateToProps = () => ({});

export default connect(mapStateToProps)(EventCalendarView);
